import React from "react";
import { Route, Switch } from "react-router";
import { BrowserRouter as Router } from "react-router-dom";
// import Error from "./Error";
import '../src/css/stylesheet.css';
import '../src/css/style.css';
import '../src/css/Home_new.css';
import '../src/font/stylesheet.css';
import '../src/css/header.css';
import '../src/css/footer.css';
import '../src/css/responsive.css';
import '../src/css/responsive_new.css';
// import Home from "./Home";
import ScrollToTop from "./ScrollToTop";
// import { Aboutus } from "./Aboutus";
// import Project_details from "./Project-details";
// import Project_details2 from "./Project-details2";
// import Project_details_jpfram from "./Project-details-jpfram";
// import  Business_Park from "./Business Park.js";
// import { Project } from "./Project";
// import { Project2 } from "./Project2";
// import { Project3 } from "./Project3";
// import { Contact } from "./Contact";
// import { Ishan } from "./Ishan";
// import { Pradeep } from "./Pradeep";
// import { Richa } from "./Richa";
// import { Shaurya } from "./Shaurya";
import Home2 from "./home404.js";
// import Error404 from "./Error404.js";

const App = () => {
  return (
    <>
    <Router>
    <ScrollToTop/>
      <Switch>
        {/* <Route exact path="/" component={Home}></Route>
        <Route exact path="/about-ripss" component={Aboutus}></Route>
        <Route exact path="/projects/residences" component={Project}></Route>
        <Route exact path="/projects/retail" component={Project2}></Route>
        <Route exact path="/projects/offices" component={Project3}></Route>
        <Route exact path="/projects/belgravia-homes" component={Project_details}></Route>
        <Route exact path="/projects/lords-square" component={Project_details2}></Route>
        <Route exact path="/projects/jp-farms" component={Project_details_jpfram}></Route>
        <Route exact path="/projects/Business-Park" component={Business_Park}></Route>
        <Route exact path="/ishan-aggarwal" component={Ishan}></Route>
        <Route exact path="/pardeep-aggarwal" component={Pradeep}></Route>
        <Route exact path="/richa-aggarwal" component={Richa}></Route>
        <Route exact path="/shaurya-aggarwal" component={Shaurya}></Route>
        <Route exact path="/contact-us" component={Contact}></Route>
        <Route component={Error404}></Route> */}
        <Route component={Home2}></Route>
      </Switch>
      </Router>
    </>
  );
};

export default App;